import {GreenCheckIcon, PinkNoCheckIcon, GrayNoCheckIcon, GrayTabSelectedIcon, GrayTabNoSelectIcon } from './images'

import {shoppingCart, claimCollaboOfferClicked } from './cart'



// =========================================================
//                   | TAB CONTROLLER |
// =========================================================
// (If on a page they aren't available, there won't be any errors. We are using arrays from querySellectorAll)

export function InitializeTabControls() {
  // Wire TabController Icon and Target Display plus Data Change for Tabbed Div Contents.
  document.querySelectorAll('.tab-controller').forEach(tab => {
    tab.addEventListener('click', collaboTabClicked(tab));
  });

  // Wire Selected Package Duration Icon Change and Set Package and claim data attributes
  document.querySelectorAll('.collabo-price-details').forEach(item => {
    item.addEventListener('click', collaboPriceDetailsClicked(item));
  });


  // Add Event Listener to Claim combo offer button (Not using closure for item)
  document.querySelectorAll('.claim-collabo-offer').forEach(item => {
    item.addEventListener('click', claimCollaboOfferClicked);
  });


    // Activate second tab by default
    let StandardTab = document.querySelectorAll('.tab-controller')[1]

    if (StandardTab != null) {
        StandardTab.click();
    }
}

function collaboPriceDetailsClicked(item) {

    return (event) => {

        // Run when event occurs
        document.querySelectorAll('.collabo-price-details').forEach(div => {
            const img = div.querySelector("img");
            const priceSpan = div.querySelector("span");           

            if (div === item) { //If eventListener is same as this div
            // Would closure work here? or we should take in event object and take.target? (event.target kind of didn't work well. Couldn't get children element by event.target.querySelector("img") So I used closure to lock in item. Maybe using document.querySelector on event.target could work)

                // Add the Green Check Icon
                img.src = GreenCheckIcon;
                item.classList.add("selected")

                // Maybe use e.target instead of item to be safer
                const duration = item.getAttribute('data-package')

                // Set global variable to track the package
                CollaboPackageDuration = duration

                // Build Package Code
                let packageCode = CollaboPackage + "_COACHING_" + duration

                if (CollaboPackage == "welfare") {
                packageCode = CollaboPackage + "_" + duration
                }
                packageCode = packageCode.toUpperCase()

                console.log("packageCode is: ", packageCode)

                // Set Windows Global CollaboPackageCode
                CollaboPackageCode = packageCode

                let packageData = siteCoachingPackageByCode[packageCode]

                if (packageData == null){
                    // Todo: Show error, Could not get package data
                    console.log("no package found")
                    return
                }

            } else {
                img.src = GrayNoCheckIcon;
                div.classList.remove("selected")
                // priceSpan.textContent = packageData.formatted_price;
            }

        });
    }
}


// Event Listener for Collabo Tabs
function collaboTabClicked(tab) {

    return (event) => {

        const preTargetId = tab.getAttribute('data-target');
        const targetId = preTargetId + "-benefits"
            
            
        // Set global variable to track the package the vip part
        CollaboPackage = preTargetId

        // console.log("targetId is: ", targetId)

        // Update all tab controller images icon inactive and hide all content
        document.querySelectorAll('.tab-controller').forEach(t => {
            t.querySelector("img").src = GrayTabNoSelectIcon;
            t.classList.remove("selected")
        });

        // Activate clicked tab icon to tab controller and set background selected
        tab.querySelector("img").src = GrayTabSelectedIcon;
        tab.classList.add("selected")

        // Change the Content Category Heading
        let packageBenefitTitle = preTargetId.toUpperCase() + " Benefits"
        document.querySelector(".package-benefits-title").textContent = packageBenefitTitle

        // Remove active state from all content containers
        document.querySelectorAll('.content-container').forEach(content => {
            content.classList.remove("active");
        });

        // Add Active class to the target content-container
        document.getElementById(targetId).classList.add("active");

        // Handle Data Change based on Server Private Coaching Data
        // Use [targetId.toUppercase "-1c, -2c, -3c"] from map of private coaching products
        // Use the object to populate fields price 

        document.querySelectorAll('.collabo-price-details').forEach(div => {
            const priceSpan = div.querySelector("span");

            // Maybe use e.target instead of item to be safer
            const duration = div.getAttribute('data-package')

            // Set global variable to track the package
            CollaboPackageDuration = duration

            // Build Package Code
            let packageCode = CollaboPackage + "_COACHING_" + duration

            if (CollaboPackage == "welfare") {
            packageCode = CollaboPackage + "_" + duration
            }
            packageCode = packageCode.toUpperCase()

            let packageData = siteCoachingPackageByCode[packageCode]

            if (packageData == null){
            // Todo: Show error, Could not get package data

            return
            }
            priceSpan.textContent = packageData.formatted_price;

        });


        // Click the first duration element
        const oneCycleDetails =  document.querySelectorAll('.collabo-price-details')[0]
        if (oneCycleDetails != null) {
            oneCycleDetails.click();
        }
    }

}